<template>
  <div id="order-apply" v-loading="loading">
    <form class="row search-pannel" :class="{ fold: fold }" @submit.prevent="doQuery">
      <input type="submit" style="display:none" />
      <div class="col-sm-3">
        <el-input size="small" v-model="query.applierName" placeholder="申请人" clearable />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.keyword" placeholder="关键字" clearable />
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.state" placeholder="状态" clearable>
          <el-option label="待审批" :value="0" />
          <el-option label="审核通过" :value="1" />
          <el-option label="订单已生成" :value="2" />
          <el-option label="审核未通过" :value="3" />
        </el-select>
      </div>
      <div class="folder">
        <el-button type="primary" size="small" @click="doQuery">确定</el-button>
        <el-button type="success" size="small" @click="doCreate">创建</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">{{ fold ? '展开' : '收起' }}<i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" /></el-button>
      </div>
    </form>
    <div class="data-header">
      <div class="row" :style="{ paddingRight: hasScroll ? scrollBarWidth + 'px' : 'px' }">
        <div v-if="!isSaler" class="col-sm-4">申请人</div>
        <div class="col-sm-4">申请时间</div>
        <div class="col-sm-6">客户名</div>
        <div class="col-sm-2">状态</div>
        <div :class="isSaler ? 'col-sm-8' : 'col-sm-4'">内容</div>
        <div class="col-sm-4">订单</div>
      </div>
    </div>
    <div ref="dataList" class="data-list">
      <template v-if="list && list.length">
        <div v-for="item in list" :key="item.id" class="order-apply-wraper">
          <div class="order-apply-item row">
            <div v-if="!isSaler" class="col-sm-4">
              <label>申请人</label>
              <div>{{ item.applierName }}</div>
            </div>
            <div class="col-sm-4">
              <label>申请时间</label>
              <div>{{ item.createTime }}</div>
            </div>
            <div class="col-sm-6">
              <label>客户名</label>
              <div>
                {{ item.companyName }}
              </div>
            </div>
            <div class="col-sm-2">
              <label>状态</label>
              <div>
                {{ ApplyStateEnum[item.state] }}
              </div>
            </div>
            <div :class="isSaler ? 'col-sm-8' : 'col-sm-4'">
              <label>内容</label>
              <div>
                <el-button type="text" size="mini" @click="showContext(item)">查看</el-button>
              </div>
            </div>
            <div class="col-sm-4">
              <label>订单</label>
              <div>
                <el-link v-if="item.state === 2" :href="'/order/detail/' + item.orderId">{{ item.orderSn }}</el-link>
                <span v-else>--</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div v-else class="no-data">
        暂无数据~
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size.sync="pagination.pageSize"
        @current-change="doLoadData"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { ListOrderAppy, ApplyState } from './services'
import { bind, unbind } from '@/utils/eventBinder.js'
import _ from 'lodash'
export default {
  name: 'OrderAppy',
  data () {
    return {
      fold: true,
      loading: false,
      ApplyStateEnum: ApplyState,
      query: {
        applierName: undefined,
        state: undefined,
        keyword: undefined
      },
      statistics: [],
      list: [],
      hasScroll: false,
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
    }
  },
  computed: {
    auth () {
      return this.$store.state.auth || {}
    },
    isSaler () {
      return this.auth.id !== 1
    },
    renderRow () {
      return this.list.length
    },
    scrollBarWidth () {
      return this.$store.state.scrollbarWidth
    }
  },
  watch: {
    renderRow () {
      this.$nextTick(() => {
        this.checkScrollbar()
      })
    }
  },
  mounted () {
    this.checkScrollBarDebounce = _.debounce(() => {
      this.checkScrollbar()
    }, 50)
    bind(window, 'resize', this.checkScrollBarDebounce)
    this.doLoadData()
  },
  beforeDestory () {
    unbind(window, 'resize', this.checkScrollBarDebounce)
  },
  methods: {
    doTest () {
      this.modal('OfficalInfoModal')
    },
    showContext (item) {
      this.modal('ApplyContextDetailModal', item.applyContext, item.state, item.approveToken)
    },
    doCreate () {
      this.modal('ReverseOrderApplyModal').promise.then(() => {
        this.doLoadData()
      })
    },
    doQuery () {
      this.pagination.pageIndex = 1
      this.doLoadData()
    },
    doLoadData () {
      if (this.loading) return
      this.loading = true
      const { pageIndex, pageSize } = this.pagination
      const { state, keyword, applierName } = this.query
      ListOrderAppy({
        applierName: (applierName && applierName.trim && applierName.trim()) || undefined,
        state: state === '' ? undefined : state,
        keyword,
        pageIndex,
        pageSize
      }).then((resp) => {
        this.list = resp.items
        const { pageIndex, pageSize, totalCount } = resp.pagination
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
      }).finally(() => {
        this.loading = false
      })
    },
    checkScrollbar () {
      const dataList = this.$refs.dataList
      if (dataList) {
        this.hasScroll = dataList.clientHeight < dataList.scrollHeight
      } else {
        this.hasScroll = false
      }
    }
  }
}
</script>
